export const JSON_ONE = {
   
  
    "ag_id": "paygate",
    "user_id": "mayur4367",
    "mer_bussiness_details": 

{

    "bussiness_description": "This is for testing only",
    "office_address": "Test",
    "country_code": "Ind",
    "state": "Maharashtra",
    "city": "Mumbai",
    "pincode": "323223",
    "category_id": "20",
    "sub_category": "Entertainment",
    "director_name": "Faming",
    "pan_number": "PPESR2231Q",
    "director_email": "mandy@gmail.com",
    "company_phone": "8859513309",
    "director_phone": "8859513809",
    "turnover": "1000000",
    "average_ticket_size": "1"

},
"mer_bank_details": 
{

    "bank_id": "1",
    "account_type": "C",
    "account_number": "2344424",
    "account_holder_name": "Thrinath",
    "settlement_currency": "INR",
    "ifsc_code": "HDFC0000218",
    "bank_city": "Hyderabad"

}
    }



